/* eslint-disable max-len */
import cn from '@sindresorhus/class-names';
import Link from 'next/link';

import styles from './PageButton.module.scss';
import getAriaLabel from './utils/getAriaLabel';

type Props = {
  href: string;
  pageNumber: number;
  isCurrent?: boolean;
  isEllipsis?: boolean;
  className?: string;
};

export const PageButton = ({
  href,
  pageNumber,
  isCurrent,
  isEllipsis,
  className,
}: Props) => {
  return (
    <Link
      href={href}
      prefetch={false}
      className={cn(
        styles.page,
        isCurrent && styles.current,
        isEllipsis && styles.ellipsis,
        className,
      )}
      aria-current={isCurrent ? 'page' : undefined}
      aria-label={isCurrent ? undefined : getAriaLabel(pageNumber)}
    >
      {isEllipsis ? '⋯' : `${pageNumber}`}
    </Link>
  );
};
